import React, { useState, useEffect, Fragment } from 'react';
import { useHistory, Link } from 'react-router-dom';
import Select from 'react-select';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip, Button, CircularProgress
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CopyrightIcon from '@mui/icons-material/Copyright';
// Assume fetchData and postData are defined elsewhere
import { fetchData, updateData, postData } from '../../../apiService';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import PrintIcon from '@mui/icons-material/Print';
import { Box } from '@mui/material';
import QAPrint from './Print';
import ReactDOM from 'react-dom';
import Info from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';

const InvoiceDetails = () => {
    const { id } = useParams();
    const history = useHistory();
    // const companyId = 2;
    // const userId = 1;
    const [isLoading, setIsLoading] = useState(false);
    const [groupedData, setGroupedData] = useState({});
    const [errorMessage, setErrorMessage] = useState("");
    const [formData, setFormData] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [loading, setLoading] = useState(false);
    const [isModalGrpOpen, setIsModalGrpOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editFormData, setEditFormData] = useState({
        InvoiceDate: '',
        InvoiceNo: '',
    });

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated]);

    // Date Format 
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const [selectedTCItems, setSelectedTCItems] = useState([]);

    useEffect(() => {
        const fetchInvoiceData = async () => {
            try {
                const response = await fetchData('InvoiceApi', `/InvoiceDetails/${id}`, token);

                if (response.responseCode === '1111') {
                    const invoiceData = response.response_data.Invoice;
                    setFormData(invoiceData);

                    // If Invoice has QuotationId, fetch Quotation details
                    if (invoiceData.QuotationId) {
                        try {
                            const quotationResponse = await fetchData('QuotationApi', `/Quotation/${invoiceData.QuotationId}`, token);
                            if (quotationResponse.responseCode === '1111') {
                                const quotationData = quotationResponse.response_data.Quotation;
                                // Merge Quotation fields into formData
                                setFormData(prev => ({
                                    ...prev,
                                    QuotationDate: quotationData.QuotationDate,
                                    QuotationNumber: quotationData.QuotationNumber,
                                    RevisionNumber: quotationData.RevisionNumber,
                                }));
                            }
                        } catch (error) {
                            console.error('Error fetching Quotation details:', error);
                        }
                    }

                    // Normalize field names for consistency
                    const invoiceDetails = response.response_data.InvoiceDetails || [];
                    const normalizedDetails = invoiceDetails.map(item => ({
                        ...item,
                        // Ensure all required fields exist with consistent naming
                        WorkItemName: item.WorkItemName || item.WorkdItemName || "",
                        DetailsName: item.DetailsName || item.Name || "",
                        WorkDetailsName: item.WorkDetailsName || item.WorkdDetailsName || item.Description || "",
                        Name: item.Name || item.DetailsName || "",
                        Description: item.Description || item.WorkDetailsName || item.WorkdDetailsName || "",
                    }));

                    setSelectedItems(normalizedDetails);
                    setSelectedTCItems(response.response_data.QATermsAndCondition || []);
                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,
                    }));
                }
            } catch (error) {
                console.error('Error fetching Invoice Details:', error);
            }
        };

        fetchInvoiceData();
    }, [id, token, userId]);

    //const [groupedData, setGroupedData] = useState({}); 

    useEffect(() => {
        // Transform flat selectedItems to nested structure grouped by QAChildDetailName and WorkName
        const nested = {};

        selectedItems.forEach(item => {
            const qaName = item.QAChildDetailName || "Uncategorized";
            const workName = item.WorkName;

            if (!nested[qaName]) {
                nested[qaName] = {};
            }
            if (!nested[qaName][workName]) {
                nested[qaName][workName] = [];
            }

            nested[qaName][workName].push(item);
        });

        setGroupedData(nested);
    }, [selectedItems]);

    const [searchQuery, setSearchQuery] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const handleSearch = (event) => setSearchQuery(event.target.value);


    const [expandedGroups, setExpandedGroups] = useState({});

    useEffect(() => {
        // Initialize expanded groups for nested structure (QA sections and Work groups)
        const initialExpanded = {};

        Object.entries(groupedData).forEach(([qaName, workGroups]) => {
            Object.keys(workGroups).forEach((workName) => {
                initialExpanded[`${qaName}-${workName}`] = true;
            });
        });

        setExpandedGroups(initialExpanded);
    }, [groupedData]);

    const toggleGroup = (key) => {
        setExpandedGroups(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };



    const filteredGroupedDataByQA = Object.entries(groupedData).reduce((acc, [qaName, workGroups]) => {
        const filteredWorkGroups = {};

        Object.entries(workGroups).forEach(([workName, items]) => {
            // Filter items by search query
            const filteredItems = items.filter(item =>
                Object.values(item).some(val =>
                    String(val).toLowerCase().includes(searchQuery.toLowerCase())
                )
            );

            if (filteredItems.length > 0) {
                filteredWorkGroups[workName] = filteredItems;
            }
        });

        if (Object.keys(filteredWorkGroups).length > 0) {
            acc[qaName] = filteredWorkGroups;
        }

        return acc;
    }, {});

    const LoadTermsAndConditions = () => {
        if (!isModalGrpOpen) {

        }
        setIsModalGrpOpen(!isModalGrpOpen);
    };

    // ✅ Close modal
    const handleCloseModalTC = () => {
        setIsModalGrpOpen(false);
    };

    // Edit Modal Functions
    const handleOpenEditModal = () => {
        setEditFormData({
            InvoiceDate: formData.InvoiceDate ? formData.InvoiceDate.split('T')[0] : '',
            InvoiceNo: formData.InvoiceNo || '',
        });
        setIsEditModalOpen(true);
    };

    const handleCloseEditModal = () => {
        setIsEditModalOpen(false);
        setErrorMessage('');
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditFormData(prev => ({ ...prev, [name]: value }));
    };

    // const handleUpdateInvoice = async () => {
    //     setErrorMessage('');

    //     // Validate inputs
    //     if (!editFormData.InvoiceNo) {
    //         setErrorMessage('Invoice Number is required!');
    //         return;
    //     }

    //     if (!editFormData.InvoiceDate) {
    //         setErrorMessage('Invoice Date is required!');
    //         return;
    //     }

    //     setIsLoading(true);

    //     try {
    //         const updatePayload = {
    //             ...formData,
    //             InvoiceDate: editFormData.InvoiceDate,
    //             InvoiceNo: editFormData.InvoiceNo,
    //             ModifiedBy: userId,
    //         };

    //         const response = await updateData('InvoiceApi', `${formData.Id}`, updatePayload, token);

    //         if (response.responseCode === '1111') {
    //             setIsLoading(false);
    //             setIsEditModalOpen(false);
    //             // Navigate to invoice index page
    //             history.push('/InvoiceIndex');
    //         } else {
    //             setErrorMessage(response.response || 'Error updating invoice. Please try again.');
    //             setIsLoading(false);
    //         }
    //     } catch (error) {
    //         console.error('Error updating invoice:', error);
    //         setErrorMessage('Error updating invoice: ' + (error.message || 'Please try again.'));
    //         setIsLoading(false);
    //     }
    // };

    const handleUpdateInvoice = async () => {
        setErrorMessage('');

        if (!editFormData?.InvoiceNo) {
            setErrorMessage('Invoice Number is required!');
            return;
        }

        if (!editFormData?.InvoiceDate) {
            setErrorMessage('Invoice Date is required!');
            return;
        }

        setIsLoading(true);

        try {
            const updatePayload = {
                Invoice: {
                    ...formData,
                    InvoiceNo: editFormData.InvoiceNo,
                    InvoiceDate: editFormData.InvoiceDate,
                    ModifiedBy: userId,
                }
            };

            const response = await updateData(
                'InvoiceApi',
                formData.Id,
                updatePayload,
                token
            );

            if (response?.responseCode === '1111') {
                setIsLoading(false);
                setIsEditModalOpen(false);
                history.push('/Invoice');
            } else {
                setErrorMessage(
                    response?.response || 'Error updating invoice. Please try again.'
                );
                setIsLoading(false);
            }
        } catch (error) {
            console.error('Error updating invoice:', error);
            setErrorMessage(
                'Error updating invoice: ' + (error?.message || 'Please try again.')
            );
            setIsLoading(false);
        }
    };

    return (
        <div
            style={{
                fontFamily: "Segoe UI, sans-serif",
                fontSize: "12px",
                width: "100%",
                padding: "5px",
                marginTop: '-15px'
            }}
        >
            {/* Header */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #ccc",
                    paddingBottom: "6px",
                    marginBottom: "12px",
                    // marginTop: '-40px'
                }}
            >
                <h6 className="uppercase tracking-wide font-serif text-black mt-2">
                    Invoice Details
                </h6>

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1.5fr 0.8fr 0.8fr", // Customer field longer
                        gap: "12px",
                        marginBottom: "12px",
                        alignItems: "end",
                    }}
                >
                    {/* Customer */}
                    <div>
                        <label
                            style={{
                                fontSize: "11px",
                                fontWeight: "600",
                                display: "block",
                                marginBottom: "4px",
                                color: "red",
                            }}
                        >
                            Customer
                            <span style={{ color: "black", marginLeft: "8px" }}>
                                (GST No: {formData?.GSTNumber || "-"})
                            </span>
                        </label>
                        <input
                            type="text"
                            name="CustomerName"
                            value={formData.CustomerName}
                            disabled
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "12px",
                                height: "28px",
                                width: "100%",
                                padding: "0 6px",
                            }}
                        />
                    </div>

                    {/* Invoice Date */}
                    <div>
                        <label style={{ fontSize: "11px", fontWeight: "600" }}>Invoice Date</label>
                        <input
                            name="InvoiceDate"
                            value={formatDate(formData.InvoiceDate)}
                            disabled
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "12px",
                                height: "28px",
                                width: "100%",
                                padding: "0 6px",
                            }}
                        />
                    </div>

                    {/* Invoice No */}
                    <div>
                        <label style={{ fontSize: "11px", fontWeight: "600" }}>Invoice No</label>
                        {/* <input
                            type="text"
                            name="QuotationNumber"
                            value={`INV/${formData.InvoiceNumber}/${formData.FinYear}`}
                            disabled
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "12px",
                                height: "28px",
                                width: "100%",
                                padding: "0 6px",
                            }}
                        /> */}
                        <input
                            type="text"
                            name="QuotationNumber"
                            value={formData.InvoiceNo}
                            disabled
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "12px",
                                height: "28px",
                                width: "100%",
                                padding: "0 6px",
                            }}
                        />
                    </div>
                </div>


                <div className="flex items-center gap-3 mt-2 md:mt-0" style={{ flexShrink: 0 }}>
                    <>
                        {/* Terms & Conditions Button */}
                        <Button
                            variant="contained"
                            onClick={LoadTermsAndConditions}
                            style={{
                                height: "25px",
                                minWidth: "80px",
                                borderRadius: "6px",
                                backgroundColor: "#149a9eff",
                                color: "#FFFFFF",
                                fontWeight: 600,
                                fontSize: "13px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                textTransform: "none",
                                transition: "background-color 0.2s, box-shadow 0.2s",
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#047074ff")}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#149a9eff")}
                        >
                            {isLoading ? <CircularProgress size={20} color="inherit" /> : "Terms & Conditions"}
                        </Button>

                        {/* ✅ Modal */}
                        {isModalGrpOpen && (
                            <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
                                <div
                                    className="bg-white p-6 rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto animate-zoomIn"
                                >
                                    {/* Header with Close Button */}
                                    <div className="flex justify-between items-center mb-4 border-b pb-2">
                                        <h6 className="uppercase tracking-wide font-serif text-black mt-2">
                                            Terms & Conditions
                                        </h6>
                                        <IconButton onClick={handleCloseModalTC}>
                                            <CloseIcon />
                                        </IconButton>
                                    </div>

                                    {/* Table Section */}
                                    <div
                                        className="w-full"
                                        style={{ maxHeight: "520px", overflowY: "auto", width: "100%", marginTop: '-15px' }}
                                    >
                                        <TableContainer
                                            component={Paper}
                                            sx={{
                                                maxHeight: 400, // 👈 set a fixed height to enable scrolling
                                                border: "1px solid #f4dfdf",
                                            }}
                                        >
                                            <Table stickyHeader>
                                                <TableHead>
                                                    <TableRow sx={{ backgroundColor: "#0f3460" }}>
                                                        {/* <TableCell sx={{ color: "white", fontWeight: "bold", padding: '3px', backgroundColor: "#071b33ff", fontSize: "12px" }}></TableCell> */}
                                                        <TableCell sx={{ color: "white", fontWeight: "bold", padding: '3px', backgroundColor: "#071b33ff", fontSize: "12px" }}>Sl.No</TableCell>
                                                        <TableCell sx={{ color: "white", fontWeight: "bold", padding: '3px', backgroundColor: "#071b33ff", fontSize: "12px" }}>Name</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {selectedTCItems && selectedTCItems.length > 0 ? (
                                                        selectedTCItems.map((item, index) => (
                                                            <TableRow
                                                                key={item.Id || index}
                                                                sx={{
                                                                    "&:hover": { backgroundColor: "#F1E7E7" },
                                                                    transition: "background-color 0.3s ease-in-out",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                {/* Serial No */}
                                                                <TableCell
                                                                    sx={{
                                                                        padding: "4px",
                                                                        borderRight: "1px solid #f4dfdf",
                                                                        fontSize: "12px",
                                                                        width: "10%",
                                                                    }}
                                                                >
                                                                    {index + 1}
                                                                </TableCell>

                                                                {/* Name */}
                                                                <TableCell
                                                                    sx={{
                                                                        padding: "4px",
                                                                        fontSize: "12px",
                                                                    }}
                                                                >
                                                                    {item.Name}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell colSpan={3} align="center" sx={{ padding: "20px" }}>
                                                                {isLoading ? "Loading..." : "No terms found."}
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>

                    {/* Edit Button */}
                   {/* <Button
                        variant="contained"
                        onClick={handleOpenEditModal}
                        style={{
                            height: "25px",
                            minWidth: "90px",
                            borderRadius: "6px",
                            backgroundColor: "#ee7373ff",
                            color: "white",
                            fontWeight: 600,
                            fontSize: "13px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            textTransform: "none",
                            transition: "background-color 0.2s, box-shadow 0.2s",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#e04646ff")}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#ee7373ff")}
                    >
                        Edit
                    </Button>*/}

                    {/* Back To List Button */}
                    <Button
                        variant="contained"
                        component={Link}
                        to="/InvoiceIndex"
                        className="linkcolor"
                        onClick={() => localStorage.setItem("shouldReload", "true")}
                        style={{
                            height: "25px",
                            minWidth: "90px",
                            borderRadius: "6px",
                            backgroundColor: "#F3F4F6", // light gray ERP style
                            color: "#1E3A8A",
                            fontWeight: 600,
                            fontSize: "13px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            textTransform: "none",
                            transition: "background-color 0.2s, box-shadow 0.2s",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#E5E7EB")}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#F3F4F6")}
                    >
                        Back To List
                    </Button>
                </div>
            </div>

            {/* <div className="grid grid-cols-12 gap-1 p-4 mb-3 rounded-lg bg-gray-100 -mt-2" style={{ marginTop: '-20px', background: '#F1F0E9' }}> */}
            <div
                style={{
                    display: "grid",
                    // gridTemplateColumns: "250px repeat(7, 1fr)", 
                    gridTemplateColumns: "repeat(10, 1fr)",
                    gap: "10px",
                    marginBottom: "12px",
                    alignItems: "end" // ✅ aligns all inputs properly
                }}
            >
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>QA Date</label>
                    <input
                        name="QuotationDate"
                        value={formData.QuotationDate ? formatDate(formData.QuotationDate) : '-'}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>
                        QA No
                    </label>
                    <input
                        type="text"
                        name="QuotationNumber"
                        value={formData.QuotationNumber || '-'}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600", color: 'red' }}>
                        QA Revision No
                    </label>
                    <input
                        type="text"
                        name="RevisionNumber"
                        value={formData.RevisionNumber || ''}
                        disabled
                        style={{
                            border: "1px solid #dd8989ff",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Amount</label>
                    <input
                        type="number"
                        name="Amount"
                        value={formData.Amount}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Taxable Amount</label>
                    <input
                        type="number"
                        name="TaxableAmount"
                        value={formData.TaxableAmount}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>CGST</label>
                    <input
                        type="number"
                        name="CGSTAmount"
                        value={formData.CGSTAmount}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>SGST</label>
                    <input
                        type="number"
                        name="SGSTAmount"
                        value={formData.SGSTAmount}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>IGST</label>
                    <input
                        type="number"
                        name="IGSTAmount"
                        value={formData.IGSTAmount}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Round Off</label>
                    <input
                        type="number"
                        name="RoundOff"
                        value={formData.RoundOff}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Total Amount</label>
                    <input
                        type="number"
                        name="TotalAmount"
                        value={formData.TotalAmount}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                {/* ---------------- Row 3 ---------------- */}
                {/* Remarks */}

                <div className="col-span-12 md:col-span-3">
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Work Name</label>
                    <input
                        type="text"
                        name="WorkName"
                        value={formData.WorkName}
                        disabled
                        placeholder="Enter Work Name"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                        }}
                    />
                </div>

                <div className="col-span-12 md:col-span-3">
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Bill Header</label>
                    <input
                        type="text"
                        name="Description"
                        value={formData.Description}
                        disabled
                        placeholder="Enter Description"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                        }}
                    />
                </div>

                <div className="col-span-12 md:col-span-3">
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Remarks</label>
                    <input
                        type="text"
                        name="Remarks"
                        value={formData.Remarks}
                        disabled
                        placeholder="Enter Remarks"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                        }}
                    />
                </div>

            </div>

            {/* Grouped Table */}
            {
                Object.keys(filteredGroupedDataByQA).length > 0 && (
                    <div className="mb-2"
                        style={{
                            maxHeight: "500px",
                            overflowY: "auto",
                            overflowX: "auto",
                            marginBottom: "12px",
                            border: "1px solid #999",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                            width: "100%",
                        }}>
                        {/* <TableContainer component={Paper}> */}
                        <table
                            style={{
                                minWidth: "1780px",
                                width: "100%",
                                borderCollapse: "collapse",
                                fontSize: "13px",
                                fontFamily: "monospace",
                                tableLayout: "fixed",
                            }}
                        >
                            <thead
                                style={{
                                    backgroundColor: "#1F2A38",
                                    color: "#FFFFFF",
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 2,
                                }}
                            >
                                <TableRow>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '60px', minWidth: '60px', textAlign: 'left', position: 'sticky', left: '0', backgroundColor: '#1F2A38', zIndex: '3' }}>Sl.No</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '400px', minWidth: '400px', textAlign: 'left', position: 'sticky', left: '60px', backgroundColor: '#1F2A38', zIndex: '3' }}>Description</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '100px', minWidth: '100px', textAlign: 'left' }}>UOM</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '100px', minWidth: '100px', textAlign: 'center' }}>QTY</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '120px', minWidth: '120px', textAlign: 'center' }}>RATE</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '120px', minWidth: '120px', textAlign: 'center' }}>AMOUNT</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '120px', minWidth: '120px', textAlign: 'center' }}>TAXABLE</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '120px', minWidth: '120px', textAlign: 'center' }}>GST ₹</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '120px', minWidth: '120px', textAlign: 'center' }}>TOTAL</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '180px', minWidth: '180px', textAlign: 'left' }}>Remarks</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '180px', minWidth: '180px', textAlign: 'left' }}>Item Remark</TableCell>
                                </TableRow>
                            </thead>
                            <TableBody>
                                {Object.entries(filteredGroupedDataByQA).map(([qaName, workGroups], qaIndex) => (
                                    <React.Fragment key={qaIndex}>

                                        {/* Main QAChildDetailName Header */}
                                        <tr style={{ backgroundColor: "#CBD99B", textAlign: 'center' }}>
                                            <td
                                                colSpan={11}
                                                style={{
                                                    fontWeight: "bold",
                                                    fontSize: "13px",
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                {qaName}
                                            </td>
                                        </tr>

                                        {/* WorkName Groups */}
                                        {Object.keys(workGroups).map((workName, groupIndex) => (
                                            <React.Fragment key={groupIndex}>
                                                {/* WorkName Sub-header */}
                                                {/* <TableRow onClick={() => toggleGroup(`${qaName}-${workName}`)} style={{ cursor: 'pointer' }}>
                                                    <TableCell colSpan={11} style={{
                                                        backgroundColor: '#f0e8dfff',
                                                        color: 'black',
                                                        fontWeight: 'bold',
                                                        textTransform: 'uppercase',
                                                        fontSize: '12px',
                                                        padding: '4px',
                                                    }}>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            <span>{workName}</span>
                                                            <span style={{ fontSize: '14px' }}>
                                                                {expandedGroups[`${qaName}-${workName}`] ? '▲' : '▼'}
                                                            </span>
                                                        </div>
                                                    </TableCell>
                                                </TableRow> */}

                                                <tr
                                                    onClick={() => toggleGroup(`${qaName}-${workName}`)}
                                                    style={{
                                                        backgroundColor: "#f3ecd9",
                                                        cursor: "pointer",
                                                        textTransform: 'uppercase',
                                                    }}
                                                >
                                                    <td colSpan={11} style={{ fontWeight: "bold" }}>
                                                        {workName}{" "}
                                                        <span style={{ float: "right" }}>
                                                            {expandedGroups[`${qaName}_${workName}`] ? "▲" : "▼"}
                                                        </span>
                                                    </td>
                                                </tr>

                                                {/* Items */}
                                                {expandedGroups[`${qaName}-${workName}`] &&
                                                    workGroups[workName].map((item, index) => (
                                                        <TableRow key={`${qaName}-${workName}-${index}`} style={{
                                                            backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF',
                                                            borderBottom: '1px solid #E0E0E0',
                                                        }}>
                                                            <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '2px', textAlign: 'left', width: '60px', position: 'sticky', left: '0', backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF', zIndex: '1' }}>
                                                                {index + 1}
                                                            </td>
                                                            <td style={{ fontSize: '10.5px', padding: '3px', width: '400px', borderRight: '1px solid #E0E0E0', position: 'sticky', left: '60px', backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF', zIndex: '1' }}>
                                                                <span style={{ color: 'brown' }}>{item.WorkItemName}</span> / <span style={{ color: 'blue' }}>{item.DetailsName}</span> / {item.WorkDetailsName}
                                                            </td>
                                                            <td style={{ fontSize: '11px', fontWeight: 'bold', padding: '3px', width: '100px' }}>{item.UOM}</td>
                                                            <td style={{ padding: '3px', textAlign: 'right', width: '100px' }}>
                                                                <input type="number" value={item.Quantity} disabled style={{ width: "100%", textAlign: "right", border: "1px solid #bbb", borderRadius: "3px", padding: "2px" }} />
                                                            </td>
                                                            <td style={{ padding: '3px', textAlign: 'right', width: '120px' }}>
                                                                <input type="number" value={item.Rate || 0} disabled style={{ width: "100%", textAlign: "right", border: "1px solid #bbb", borderRadius: "3px", padding: "2px" }} />
                                                            </td>
                                                            <td style={{ padding: '3px', textAlign: 'right', width: '120px' }}>
                                                                <input type="number" value={item.Amount || 0} disabled style={{ width: "100%", textAlign: "right", border: "1px solid #bbb", borderRadius: "3px", padding: "2px" }} />
                                                            </td>
                                                            <td style={{ padding: '3px', textAlign: 'right', width: '120px' }}>
                                                                <input type="number" value={item.TaxableAmount || 0} disabled style={{ width: "100%", textAlign: "right", border: "1px solid #bbb", borderRadius: "3px", padding: "2px" }} />
                                                            </td>
                                                            <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                                                <input
                                                                    value={parseFloat(item.CGSTAmount) + parseFloat(item.SGSTAmount) + parseFloat(item.IGSTAmount)}
                                                                    readOnly
                                                                    style={{ width: "70%", textAlign: "right", border: "1px solid #ccc", borderRadius: "3px", padding: "2px" }}
                                                                />
                                                                <span style={{ marginLeft: "4px", color: "darkmagenta", fontSize: "11px" }}>
                                                                    {item.GSTRate ? parseFloat(item.GSTRate) : 0}%
                                                                </span>
                                                            </td>
                                                            <td style={{ padding: '3px', textAlign: 'right', width: '120px' }}>
                                                                <input type="number" value={item.TotalAmount || 0} disabled style={{ width: "100%", textAlign: "right", border: "1px solid #bbb", borderRadius: "3px", padding: "2px" }} />
                                                            </td>
                                                            <td style={{ fontSize: '11px', fontWeight: 'bold', padding: '3px', width: '180px', borderRight: '1px solid #E0E0E0', }}>
                                                                <textarea value={item.Remarks || ""} readOnly style={{ width: "100%", textAlign: "left", border: "1px solid #bbb", borderRadius: "3px", padding: "2px" }} />
                                                            </td>
                                                            <td style={{ fontSize: '11px', fontWeight: 'bold', padding: '3px', width: '180px', borderRight: '1px solid #E0E0E0', }}>
                                                                <textarea value={item.ItemRemark || ""} readOnly style={{ width: "100%", textAlign: "left", border: "1px solid #bbb", borderRadius: "3px", padding: "2px" }} />
                                                            </td>
                                                        </TableRow>
                                                    ))}
                                            </React.Fragment>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </TableBody>

                        </table>
                        {/* </TableContainer> */}
                    </div>
                )
            }

            {/* Edit Invoice Modal */}
            {isEditModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
                    <div
                        className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md animate-zoomIn"
                    >
                        {/* Header with Close Button */}
                        <div className="flex justify-between items-center mb-4 border-b pb-2">
                            <h6 className="uppercase tracking-wide font-serif text-black">
                                Edit Invoice
                            </h6>
                            <IconButton onClick={handleCloseEditModal}>
                                <CloseIcon />
                            </IconButton>
                        </div>

                        {/* Error Message */}
                        {errorMessage && (
                            <div style={{
                                backgroundColor: '#fee',
                                color: '#c33',
                                padding: '10px',
                                borderRadius: '4px',
                                marginBottom: '12px',
                                border: '1px solid #fcc',
                                fontSize: '12px'
                            }}>
                                {errorMessage}
                            </div>
                        )}

                        {/* Form Fields */}
                        <div style={{ marginBottom: '16px' }}>
                            <label style={{ fontSize: "12px", fontWeight: "600", display: 'block', marginBottom: '4px' }}>
                                Invoice Date <span style={{ color: 'red' }}>*</span>
                            </label>
                            <input
                                type="date"
                                name="InvoiceDate"
                                value={editFormData.InvoiceDate}
                                onChange={handleEditChange}
                                style={{
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    fontSize: "12px",
                                    height: "32px",
                                    width: "100%",
                                    padding: "0 8px"
                                }}
                            />
                        </div>

                        <div style={{ marginBottom: '16px' }}>
                            <label style={{ fontSize: "12px", fontWeight: "600", display: 'block', marginBottom: '4px' }}>
                                Invoice Number <span style={{ color: 'red' }}>*</span>
                            </label>
                            <input
                                type="text"
                                name="InvoiceNo"
                                value={editFormData.InvoiceNo}
                                onChange={handleEditChange}
                                placeholder="Enter Invoice Number"
                                style={{
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    fontSize: "12px",
                                    height: "32px",
                                    width: "100%",
                                    padding: "0 8px"
                                }}
                            />
                        </div>

                        {/* Info Message */}
                        <div style={{
                            backgroundColor: '#e3f2fd',
                            color: '#1565c0',
                            padding: '8px',
                            borderRadius: '4px',
                            marginBottom: '16px',
                            border: '1px solid #90caf9',
                            fontSize: '11px'
                        }}>
                            <strong>Note:</strong> Only Invoice Date and Invoice Number can be edited.
                        </div>

                        {/* Action Buttons */}
                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                            <Button
                                variant="outlined"
                                onClick={handleCloseEditModal}
                                style={{
                                    height: "32px",
                                    minWidth: "80px",
                                    borderRadius: "6px",
                                    color: "#1E3A8A",
                                    borderColor: "#1E3A8A",
                                    fontWeight: 600,
                                    fontSize: "12px",
                                    textTransform: "none",
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleUpdateInvoice}
                                disabled={isLoading}
                                style={{
                                    height: "32px",
                                    minWidth: "80px",
                                    borderRadius: "6px",
                                    backgroundColor: "#1E3A8A",
                                    color: "#FFFFFF",
                                    fontWeight: 600,
                                    fontSize: "12px",
                                    textTransform: "none",
                                }}
                            >
                                {isLoading ? <CircularProgress size={20} color="inherit" /> : "Update"}
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </div >
    );
};

export default InvoiceDetails;